import { DialogContent, DialogTitle, Stack } from "@mui/material"
import { BoundAutocomplete, BoundTextField } from "lib/@components/binding/bound-components"
import { DataInputDialog } from "lib/@dialogs/data-input-dialog"
import { htmlToText } from "lib/html-to-text"
import { BoundTextEditor } from "minimals-template/components/editor"
import { useState } from "react"
import { useDataExportRequestTypes } from "./hooks/use-data-export-request-types"

export function DataExportRequestDialog({ user, type, typeDisabled = false }) {
    const { dataExportRequestTypes } = useDataExportRequestTypes()

    const defaultType = type ? dataExportRequestTypes.find((dataExportType) => dataExportType === type) : null

    const [request] = useState({
        name: user.displayName,
        email: user.email,
        reason: "",
        dataExportType: defaultType,
    })

    return (
        <DataInputDialog initialValue={request} okCaption="Send" okIcon="ic:round-send">
            <DialogTitle sx={{ mb: 2 }}>Download Request</DialogTitle>
            <DialogContent>
                <Stack spacing={2} sx={{ mt: 1 }} data-cy="data-export-request-dialog">
                    <BoundTextField field="name" yup="string.trim.required" data-cy="export-request-name" />
                    <BoundTextField field="email" yup="string.trim.email.required" data-cy="export-request-email" />
                    <BoundAutocomplete
                        options={dataExportRequestTypes}
                        field="dataExportType"
                        disabled={typeDisabled}
                        disableClearable
                        data-cy="export-request-type"
                    />
                    <BoundTextEditor
                        field="reason"
                        label="Reason for Request"
                        simple={true}
                        yup="string.trim.required"
                        yupTransform={htmlToText}
                        sx={{ flex: 1, "& .jodit-workplace": { height: "100px !important" } }}
                    />
                </Stack>
            </DialogContent>
        </DataInputDialog>
    )
}
